import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';
import { auth, googleProvider } from '../../../service/firebase';
import { upsertUserProfile } from '../../../service/userService';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state?.from?.pathname || '/';

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await signInWithPopup(auth, googleProvider);
      await upsertUserProfile(auth.currentUser);
      navigate(redirectPath, { replace: true });
    } catch (authError) {
      console.error('Erro ao autenticar com o Google', authError);
      setError('Não foi possível entrar com o Google. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleEmailLogin = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      await upsertUserProfile(auth.currentUser);
      navigate(redirectPath, { replace: true });
    } catch (authError) {
      console.error('Erro ao autenticar com email e senha', authError);
      setError('Email ou senha inválidos. Confira os dados e tente de novo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="body">
        <div className="center">
          <div className="body-content card auth-card">
            <div className="topo-page">
              <strong># Login</strong>
            </div>
            <p className="auth-description">
              Entrar permite salvar seus amistosos, compartilhar dados e acessar relatórios mais rápido.
            </p>
            <div className="auth-actions">
              <button
                type="button"
                className="btn-default auth-google"
                onClick={handleGoogleLogin}
                disabled={loading}
              >
                Entrar com Google
              </button>
            </div>
            <div className="auth-divider">ou</div>
            <form className="auth-form" onSubmit={handleEmailLogin}>
              {error && (
                <p className="auth-error" role="alert">
                  {error}
                </p>
              )}
              <label htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                placeholder="seuemail@exemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <label htmlFor="login-password">Senha</label>
              <input
                id="login-password"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button type="submit" className="btn-default" disabled={loading}>
                {loading ? 'Entrando...' : 'Entrar com Email'}
              </button>
            </form>
            <div className="auth-footer">
              <span>É novo por aqui?</span>
              <Link to="/cadastro">Cadastrar</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
